import { useState, useEffect } from "react";
import BottomMenu from "./BottomMenu";
import { Grid, Avatar, Box } from "@mui/material";
import { shadows } from "@mui/system";
import BottomButton from "./BottomButton";
import MypageLoggedOut from "./MypageLoggedOut";
import MypageLoggedIn from "./MypageLoggedIn";
import { loginState, configState } from "../lib/State";
import Loading from "./Loading";
import get_session from "../lib/get_session";
import pr from "../lib/pr";
import axios from "axios";
import get_token from "../lib/get_token";
import get_cid from "../lib/get_cid";
import { useHistory } from "react-router-dom";

function Mypage() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const token = get_token();
  const cid = get_cid();

  const get_session = async () => {
    let result = await axios.post(configState.api + "/gympass/get_session", {
      token: token,
      cid: cid,
    });
    if (result.data.mcd !== "" && result.data.success === 1) {
      setLogin({ mcd: result.data.mcd, level: result.data.level });
    }
    setLoaded(true);
  };
  useEffect(() => {
    get_session();
  }, []);

  const history = useHistory();

  return (
    <>
      {loaded ? (
        <Grid
          container
          height={cid !== "XXXXX" /*줌*/ ? "100vh" : "100%"}
          direction="column"
        >
          <div
            className="absolute z-30 bg-white rounded-full bg-opacity-50 top-3 left-3"
            onClick={() => history.goBack()}
          >
            <img src="/img/back_button_black.png" alt="" />
          </div>
          {login.mcd === "" ? (
            <MypageLoggedOut />
          ) : (
            <MypageLoggedIn login={login} />
          )}

          <BottomButton login={login} loaded={loaded} />
          <BottomMenu active="mypage"></BottomMenu>
        </Grid>
      ) : (
        <Loading />
      )}
    </>
  );
}

export default Mypage;
